module.exports = __webpack_public_path__ + "img/插图_加入我们_02@2x.10c2bdf6.png";